export type QualityMode = 'eco' | 'standard' | 'high';

export interface QualitySettings {
  terrainMaximumScreenSpaceError: number;
  terrainTileCacheSize: number;
  buildingMaximumScreenSpaceError: number;
  buildingCacheBytes: number;
  buildingMaximumCacheOverflowBytes: number;
  buildingLod2MaximumScreenSpaceError: number;
  buildingLod2CacheBytes: number;
  roadMaximumScreenSpaceError: number;
  shadows: boolean;
  hdr: boolean;
  fogDensity: number;
  resolutionScale: number;
  orthoMaximumLevel: number;
}

export interface VisualSettings {
  shadows: boolean;
  atmosphere: boolean;
  fog: boolean;
  fogDensity: number;
  hdr: boolean;
  nightLighting: boolean;
}

export const QUALITY_SETTINGS: Record<QualityMode, QualitySettings> = {
  eco: {
    terrainMaximumScreenSpaceError: 24,
    terrainTileCacheSize: 64,
    buildingMaximumScreenSpaceError: 32,
    buildingCacheBytes: 128 * 1024 * 1024,
    buildingMaximumCacheOverflowBytes: 64 * 1024 * 1024,
    buildingLod2MaximumScreenSpaceError: 36,
    buildingLod2CacheBytes: 128 * 1024 * 1024,
    roadMaximumScreenSpaceError: 32,
    shadows: false,
    hdr: false,
    fogDensity: 0.0005,
    resolutionScale: 0.85,
    orthoMaximumLevel: 17,
  },
  standard: {
    terrainMaximumScreenSpaceError: 12,
    terrainTileCacheSize: 96,
    buildingMaximumScreenSpaceError: 20,
    buildingCacheBytes: 256 * 1024 * 1024,
    buildingMaximumCacheOverflowBytes: 128 * 1024 * 1024,
    buildingLod2MaximumScreenSpaceError: 24,
    buildingLod2CacheBytes: 192 * 1024 * 1024,
    roadMaximumScreenSpaceError: 18,
    shadows: true,
    hdr: true,
    fogDensity: 0.00035,
    resolutionScale: 1,
    orthoMaximumLevel: 19,
  },
  high: {
    terrainMaximumScreenSpaceError: 6,
    terrainTileCacheSize: 160,
    buildingMaximumScreenSpaceError: 12,
    buildingCacheBytes: 384 * 1024 * 1024,
    buildingMaximumCacheOverflowBytes: 192 * 1024 * 1024,
    buildingLod2MaximumScreenSpaceError: 16,
    buildingLod2CacheBytes: 256 * 1024 * 1024,
    roadMaximumScreenSpaceError: 12,
    shadows: true,
    hdr: true,
    fogDensity: 0.00025,
    resolutionScale: 1,
    orthoMaximumLevel: 19,
  },
};

export function visualSettingsForQuality(quality: QualityMode): VisualSettings {
  const settings = QUALITY_SETTINGS[quality];
  return {
    shadows: settings.shadows,
    atmosphere: true,
    fog: true,
    fogDensity: settings.fogDensity,
    hdr: settings.hdr,
    nightLighting: true,
  };
}

export const APP_CONFIG = {
  title: '徳島市道路・都市計画デジタルツイン',
  defaultQuality: 'eco' as QualityMode,
  camera: {
    longitude: 134.5547,
    latitude: 34.0703,
    height: 5_500,
    heading: 12,
    pitch: -48,
    roll: 0,
    duration: 2.5,
  },
  // PLATEAU-Orthoは日本全域のXYZではなく、配信済み範囲を持つため対象地域を限定する。
  orthoCoverage: {
    west: 134.30,
    south: 33.95,
    east: 134.75,
    north: 34.25,
    minimumLevel: 10,
    maximumLevel: 19,
  },
  performance: {
    terrainLod3MaximumScreenSpaceError: 8,
    terrainLod3CacheBytes: 128 * 1024 * 1024,
  },
} as const;
